export const AppConstants = {
  touchtoorder: " TOUCH TO ORDER",
};
export const OrderTypeConstants = {
  DineIn: "DINE-IN",
  Parcel: "PARCEL",
  Delivery: "DELIVERY",
};
export const REGEX = {
  PERCENTAGE_NUMBER:
    /^((100((\.|,)[0-9]{1,2})?)|([0-9]{1,2}((\.|,)[0-9]{0,2})?))$/,
  PHONE_NUMBER: /^[\s()+-]*([0-9][\s()+-]*){6,20}$/,
  POSITIVE_NUMBER: /^[.]?[0-9]+[.]?[0-9]*$/,
  POSITIVE_NUMBER_WITH_EMPTY: /^\d*\.?\d*$/,
  ORDER_PAYABLES_VALUE: /\.00$/,
  DECIMAL_NUMBER: /^\d*\.?\d*$/,
  ONLY_NUMBERS: /^\d*$/,
  OTP_SINGLE_DIGIT: /^[0-9]?$/,
  OTP_DIGITS: /^\d+$/,
  LATITUDE:
    /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  LONGITUDE:
    /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  ALLOW_TWO_DECIMAL: /^(?!0+(\.0+)?$)\d*(\.\d{0,2})?$/,
  STRONG_PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
};
export const PaymentResponseConstants = {
  completed: "COMPLETED",
  failed: "FAILED",
  failed_timeout: "TIMED_OUT",
  pending: "PENDING",
};
export const StatusConstants = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  SOLDOUT: "SOLDOUT",
};
export const PaymentStatusConstants = {
  success: "SUCCESS",
  failed: "FAILED",
  timeout: "TIMEOUT",
  pending: "PENDING",
};

export const TerminalTypes = {
  MERCHANT: "merchant-billing",
  USER: "user-billing",
};
export const AppTypes = {
  KIOSK_LINUX: "linux-kiosk",
  KIOSK_WINDOWS: "windows-kiosk",
  ANDROID_APK_MERCHANT: "android-merchant",
  ANDROID_APK_USER: "android-user",
  IPAD_OR_IOS_APPSTORE_MERCHANT: "ios-merchant",
  IPAD_OR_IOS_APPSTORE_USER: "ios-user",
  DESKTOP_LINUX: "linux-merchant",
  DESKTOP_WINDOWS: "windows-merchant",
  WEB_MERCHANT: "web-merchant",
  WEB_USER: "web-user",
};

export const BillingKeyVerification = {
  BILLINGKEYVERIFICATION: "Billing key verified",
};
export const ValidationConstants = {
  BILLINGKEY: "Enter Billing Key",
};
export const DEVICE_TYPES = {
  ANDROID_MOBILE: "Android Mobile",
  ANDROID_TABLET: "Android Tablet",
  IPAD: "Ipad",
  MAC: "Mac",
  MAC_DESKTOP_APP: "Mac Desktop App",
  IPHONE: "IPhone",
  LINUX: "Linux",
  LINUX_DESKTOP: "Linux Desktop",
  WINDOWS_DESKTOP: "Windows Desktop",
  UNKNOWN: "Unknown",
};

export const StorageConstants = {
  ALL_ADDONS_LIST: "allAddOnsList",
  ALL_GROUP_LIST: "allGroupList",
  ALL_PRODUCT_LIST: "ALL_PRODUCT_LIST",
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  MERCHANT_DETAILS: "merchantDetails",
  BILLING_KEY_STATUS: "billingKeyStatus",
  CUSTOM_CODE_MODE: "CustomCodeMode",
  CUSTOM_CODE_TYPE: "CustomCodeType",
  CUSTOM_CODES: "CustomCodes",
  PRINT_MODE: "CompleteConstant",
  DEVICE_UNIQUE_ID: "deviceUniqueId",
  CUSTOMER_INFORMATION: "CUSTOMER_INFO",
  CART_DATA: "CART_DATA",
  COUNTER_ID: "COUNTERID",
  COUNTER_SELECTED: "COUNTER_SELECTED",
  ORDER_TYPE: "ORDER_TYPE",
  LAST_LOCATION_FETCH_TIMESTAMP : "LAST_LOCATION_FETCH_TIMESTAMP"
};

export const LocalStorageKeys = {
  BILLINGKEYSTATUS: "billingKeyStatus",
};
export const PRINT_CONSTANT = {
  POS: "POS",
  PDF: "PDF",
  POS_BLUETOOTH_58MM: " POS_BLUETOOTH_58MM",
  POS_BLUETOOTH_80MM: "POS_BLUETOOTH_80MM",
  POS_USB_58MM: "POS_USB_58MM",
  POS_USB_80MM: "POS_USB_80MM",
};
export const USER_AGENTS = {
  REACT_NATIVE: "REACT_NATIVE_AGENT",
};

export const DASHBOARD_PATH = {
  ROOT: "dashboard",
  MENU: "menu",
  MENU_DISPLAY: 'menuDisplay',
  PAYMENT: "payment",
  PAYMENT_ONLINE: "paymentonline",
  PAYMENT_STATUS: "paymentstatus",
  MODE: "mode",
  THANKYOU: "thankyou",
  ACK: "acknowledge",
  PAYMENT_MODE: "paymentmode",
  ACCEPTED_SCREEN: "acceptedscreen",
  LANDING: "landing",
  OLD_ORDERS: "oldOrders",
  TRACK: "track",
  ORDER: "order",
  ORDER_DETAILS: "orderDetails",
  ORDER_STATUS: "orderStatus",
  UPI_STATUS: "upiStatus",
  COUNTER: "counter",
  CHECK_OUT: "checkout",
  ADD_ADDRESS: "addAddress",
  SETTINGS: "settings",
};

export const PRO_PATH = {
  VIEW_ONLY_PRODUCTS: "menu",
};

export const PLAN_TYPE = {
  LITE: "lite",
  PRO: "pro",
  ULTRA: "ultra",
};

export const ORDER_PAYMENT_STATUS = {
  FULL_PAYMENT: "FULL-PAYMENT",
  PARTIAL: "PARTIAL",
  CREDIT: "CREDIT",
  OFFLINE: "OFFLINE",
  HOLD: "HOLD",
};
export const SCAN_QR_STATUS = {
  OPEN: "OPEN",
  ORDER_PLACED: "ORDER-PLACED",
  DELIVERED_PARTIALLY: "DELIVERED-PARTIALLY",
  READY_TO_SERVE: "READY-TO-SERVE",
  DELIVERED: "DELIVERED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  OUT_FOR_DELIVERY: "OUT-FOR-DELIVERY",
  INITIATED: "INITIATED",
};
export const ORDER_TYPE = {
  DINE_IN: "DINE-IN",
  DELIVERY: "DELIVERY",
  PARCEL: "PARCEL",
};
export const DELIVERY_OPTIONS = {
  ONLY_DELIVERY: "ONLY DELIVERY",
  COD: "COD",
};
export const PLATFORMS = {
  IOS: "ios",
  ANDROID: "android",
};

export const ORDER_TYPE_OPTIONS = ["Dine-in", "Take-away", "Delivery"];

export const PAYMENT_METHOD = {
  UPI: "UPI",
};

export const CURRENCY_CODE = {
  INR: "INR",
};
